/* ==========================================================================
   mlx-sticky-atc.js — PDP 하단 고정 ADD TO CART (staging-phase1 / 198512443552)
   2026-08-09 · [SB] 2026-08-10 개정

   로더: sections/announcement-bar.liquid  (script + stylesheet 두 줄)
   롤백: 그 두 줄 삭제

   원칙
     1) 담을 값을 새로 정하지 않는다.
        variant id·수량은 **인페이지 폼에서 그대로 읽는다**. 쉐이드 전환·가격·품절 판정은
        여전히 테마 기존 경로가 한다.
        ★ [2026-08-10 SB] 다만 "클릭을 전달만 한다"는 종전 방식은 버렸다.
          이 테마의 PDP 는 `settings.cart_action = reload_page` 라 인페이지 ATC 가
          `<form action="/cart/add" method="post">` 를 그냥 제출한다 = 담을 때마다 새로고침.
          그 경로에는 **명시적 성공 응답이 없어서** 배지·라벨을 즉시 바꿀 수가 없다.
          카드(mlx-card-atc.js)와 동작을 맞추려면 `cart/add.js` 의 2xx 가 필요하다.
          안전망으로 실패·불확실 시에는 종전 폼 제출 경로로 떨어뜨린다.
     2) 라벨·가격·품절 상태는 인페이지 바를 **거울처럼 따라간다**.
        테마 utilities.js 의 selectCallback 이 바 안 span 을 덮어쓰므로
        섹션 JS(product__main-sf-lip.liquid) 가 되돌린 **최종 결과**만 읽는다.
     3) PDP 가 아니거나 ATC 가 없으면 아무것도 만들지 않는다(전 페이지 로드지만 무해).
     4) 성공은 **확인한 뒤에만** 말한다. 모르면 침묵한다.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__mlxStickyAtc) { return; }
  window.__mlxStickyAtc = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function u(path) { return (ROOT.charAt(ROOT.length - 1) === '/' ? ROOT : ROOT + '/') + path; }

  function init() {
    var form = document.querySelector('.product_form.sfp-form');
    var host = document.querySelector('.mlx-atc-host');
    var wrapper = document.querySelector('.sfp-form-wrapper');

    // PDP(섬머프라이데이 레이아웃)가 아니면 종료
    if (!wrapper) { return; }

    var realBtn = form ? form.querySelector('[data-add-to-cart-trigger]') : null;
    var notifyForm = wrapper.querySelector('.notify_form');

    // 담을 것도 알릴 것도 없으면 종료
    if (!realBtn && !notifyForm) { return; }

    /* ---------------------------------------------------------------
       바 만들기
       --------------------------------------------------------------- */
    var bar = document.createElement('div');
    bar.className = 'mlx-satc';
    bar.setAttribute('aria-hidden', 'true');

    var inner = document.createElement('div');
    inner.className = 'mlx-satc__inner';
    bar.appendChild(inner);

    // 썸네일 — 갤러리 메인의 현재 이미지를 그대로 쓴다
    var thumb = document.createElement('img');
    thumb.className = 'mlx-satc__thumb';
    thumb.alt = '';
    thumb.setAttribute('aria-hidden', 'true');
    inner.appendChild(thumb);

    var meta = document.createElement('div');
    meta.className = 'mlx-satc__meta';
    var nameEl = document.createElement('span');
    nameEl.className = 'mlx-satc__name';
    var variantEl = document.createElement('span');
    variantEl.className = 'mlx-satc__variant';
    meta.appendChild(nameEl);
    meta.appendChild(variantEl);
    inner.appendChild(meta);

    var titleEl = document.querySelector('.sfp-title');
    nameEl.textContent = titleEl ? titleEl.textContent.trim() : '';

    // 선택 값 표시 — 쉐이드/사이즈가 있는 상품만
    var selectedEl = document.querySelector('[data-sfp-selected-value]');
    if (!selectedEl) { bar.classList.add('mlx-satc--no-variant'); }

    /* ---------------------------------------------------------------
       [2026-08-10 SB] ③ 현재 선택 variant — 단일 진실은 `select[name="id"]`

       버그: `?variant=58584085856416`(6 Rosewood) 로 들어오면 고정 바 쉐이드 라벨이
             "0 Glass" 로 뜬다. 색을 한 번 바꾸면 그때부터는 정상 추종.

       원인(실측 2026-08-10, 같은 URL 한 페이지에서 동시에 읽음):
             select[name="id"].value          = 58584085856416   ← 정상
             .swatch :radio:checked           = "6 Rosewood"     ← 정상
             [data-sfp-selected-value]        = "0 Glass"        ← 오염
         바는 이 오염된 라벨 하나만 읽고 있었다. 라벨이 오염되는 이유는 섹션 JS
         (product__main-sf-lip.liquid) 의 syncLabel() 이 **파싱 시점에** 한 번 도는데,
         그 시점의 checked radio 가 Liquid `{% if forloop.first %}checked{% endif %}` 로
         찍힌 **항상 1번 쉐이드**이기 때문이다(테마 JS 가 뒤늦게 올바른 radio 로 옮긴다).
         → 서버가 selected 를 찍어 주는 select 를 1순위, checked radio 를 2순위로 읽고,
           오염될 수 있는 인페이지 라벨은 최후순위로 내린다.
       --------------------------------------------------------------- */
    var idSelect = form ? form.querySelector('select[name="id"], select[data-variant-selector]') : null;
    var idInput = form ? form.querySelector('input[name="id"]') : null;

    function currentVariantId() {
      if (idSelect && idSelect.value) { return String(idSelect.value); }
      if (idInput && idInput.value) { return String(idInput.value); }
      return null;
    }

    function currentOptionName() {
      if (idSelect) {
        /* selectedIndex 에 기대지 않는다 — 테마가 value 만 바꿔 놓는 경로가 있다 */
        var v = String(idSelect.value);
        for (var i = 0; i < idSelect.options.length; i++) {
          if (idSelect.options[i].value === v) {
            var t = (idSelect.options[i].text || '').trim();
            /* 옵션이 둘 이상이면 title 이 "쉐이드 / 사이즈" — 바가 쓰는 건 첫 옵션이다 */
            if (t) { return t.split(' / ')[0].trim(); }
          }
        }
      }
      var r = form ? form.querySelector('.swatch input[type="radio"]:checked') : null;
      if (r && r.value) { return String(r.value).trim(); }
      return selectedEl ? selectedEl.textContent.trim() : '';
    }

    /* ---------------------------------------------------------------
       [2026-08-10 SB] ② 담긴 신호 — 헤더 배지 · ADDED 라벨
       테마는 `[data-bind="itemCount"]` 로 배지를 바인딩한다(실측).
       우리가 fetch 로 담으면 그 경로를 타지 않으므로 직접 맞춰 준다.
       배지는 낙관적으로 올리고(bumpCount), 진짜 값은 /cart.js 응답(paintCount)이 덮는다.
       --------------------------------------------------------------- */
    function badgeEls() { return document.querySelectorAll('[data-bind="itemCount"]'); }

    function bumpCount(delta) {
      var els = badgeEls();
      for (var i = 0; i < els.length; i++) {
        var n = parseInt((els[i].textContent || '').replace(/[^0-9]/g, ''), 10);
        els[i].textContent = (isNaN(n) ? 0 : n) + delta;
      }
    }

    function paintCount(cart) {
      if (!cart || typeof cart.item_count !== 'number') { return; }
      var els = badgeEls();
      for (var i = 0; i < els.length; i++) { els[i].textContent = cart.item_count; }
    }

    function getCart() {
      return fetch(u('cart.js'), { credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) { return r.json(); });
    }

    /* ---------------------------------------------------------------
       [2026-08-10 SB2] 담기 = 바·인페이지 **공용 경로** 하나
       인페이지 ATC 도 같은 계약(cart/add.js 2xx → ADDED+배지, 검증 후 토스트)을 쓴다.
       ★ 폼 제출 폴백은 유지한다. 고객이 못 담는 상황은 0.
       --------------------------------------------------------------- */
    var qtyInput = form ? form.querySelector('input[name="quantity"]') : null;

    /* hidden return_to 는 `cart_action` 이 reload_page/redirect_cart 일 때만 렌더된다.
       없으면 테마가 스스로 AJAX 로 담는 모드 → 우리가 끼어들지 않는다(설정 변경 방어). */
    var themeSubmitsForm = !!(form && form.querySelector('input[type="hidden"][name="return_to"]'));

    function canAjax() {
      if (!window.fetch || !realBtn || !themeSubmitsForm) { return false; }
      /* 라인아이템 속성·구독은 폼이 정하는 값이다. 반만 옮기면 다른 걸 담는다 → 종전 경로. */
      if (form.querySelector('[name^="properties"]') || form.querySelector('[name="selling_plan"]')) { return false; }
      return !!currentVariantId();
    }

    /* 바와 인페이지가 **같은 폼**을 공유한다 → 잠금은 하나. 둘 다에 표시한다. */
    var busy = false;
    function setBusy(on) {
      busy = on;
      [proxyBtn, realBtn].forEach(function (b) {
        if (!b) { return; }
        if (on) {
          b.setAttribute('data-mlx-busy', '1');
          b.style.opacity = '.6';
          b.style.pointerEvents = 'none';
        } else {
          b.removeAttribute('data-mlx-busy');
          b.style.opacity = '';
          b.style.pointerEvents = '';
        }
      });
    }

    /* 종전 경로 = 인페이지 폼 제출(새로고침). 플래그로 우리 리스너를 통과시킨다. */
    var nativePass = false;
    function submitFormNatively() {
      if (!realBtn) { return; }
      nativePass = true;
      realBtn.click();
      setTimeout(function () { nativePass = false; }, 0);
    }

    function addToCart() {
      if (busy) { return; }
      var vid = currentVariantId();
      if (!vid) { submitFormNatively(); return; }
      var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      if (!qty || qty < 1) { qty = 1; }

      setBusy(true);
      var settled = false;
      function done() { setBusy(false); }

      /* 기준값을 먼저 확실히 읽고 담는다(병렬로 읽으면 레이스로 조용히 침묵한다). */
      getCart()
        .then(function (c) { return c.item_count; })
        .catch(function () { return null; })
        .then(function (before) {
          return fetch(u('cart/add.js'), {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: vid, quantity: qty }] })
          })
          .then(function (res) {
            return res.json().catch(function () { return null; })
              .then(function (b) { return { ok: res.ok, status: res.status, body: b }; });
          })
          .then(function (r) {
            if (!r.ok) {
              if (r.status >= 400 && r.status < 500 && r.body) {
                /* 명시적 실패. 침묵할 대상은 '모름'이지 '실패'가 아니다. */
                settled = true;
                toast(String(r.body.description || r.body.message || 'Could not add to cart'));
                done();
                return;
              }
              done();
              submitFormNatively();   /* 5xx·비JSON = 모름 → 종전 경로 */
              return;
            }
            /* 2xx = 담겼다는 명시적 응답. 라벨·배지는 지금 바꾸고,
               토스트만 /cart.js 증가로 재확인한 뒤에 낸다(거짓 성공 금지). */
            settled = true;
            flashAdded();
            bumpCount(qty);
            if (before === null) {
              getCart().then(paintCount).catch(function () {});   /* 판정 불가 → 침묵 */
              done();
              return;
            }
            verify(before, 0, done);
          });
        })
        .catch(function () {
          done();
          if (!settled) { submitFormNatively(); }   /* 네트워크 실패 → 종전 경로 */
        });
    }

    /* 라벨 잠금 — ADDED 를 띄운 동안에는 sync() 가 인페이지 라벨로 덮어쓰지 않게 한다.
       (form click 리스너가 +200ms 에 sync 를 부르므로 잠금이 없으면 즉시 원복된다) */
    var labelHold = 0;
    var labelHoldTimer = null;

    /* ★ 라벨이 짧아지면 폭이 밀린다 — 실측 375: 'Add to cart' 176px → 'ADDED' 169px,
         왼쪽 끝 x179 → x186. 원인은 `flex: 1 1 auto` 라 버튼 basis(=글자 폭)가
         모자란 폭을 나눠 갖는 비율에 들어가기 때문. `flex:1 1 0` 으로 바꾸면 pill 이
         제 폭을 다 가져가 버튼이 139px 로 줄어든다(후퇴) → 규격은 두고 **그 동안만 폭 고정**.
       [2026-08-10 SB2] 바·인페이지 **둘 다** 바꾼다. 어느 쪽을 눌러도 같은 확인을 준다. */
    function flashAdded() {
      var targets = [];
      [proxyBtn, realBtn].forEach(function (b) {
        var l = b && b.querySelector ? b.querySelector('.mlx-atc__label') : null;
        if (!l) { return; }
        var w = b.getBoundingClientRect().width;
        if (w > 0) { b.style.flex = '0 0 ' + w + 'px'; }
        targets.push({ b: b, l: l, prev: l.textContent });
        l.textContent = 'ADDED';
      });
      if (!targets.length) { return; }
      labelHold = Date.now() + 1600;
      clearTimeout(labelHoldTimer);
      labelHoldTimer = setTimeout(function () {
        labelHold = 0;
        targets.forEach(function (t) {
          /* 그 사이 테마가 라벨을 바꿨으면(쉐이드 변경 등) 그쪽을 존중한다 */
          if (t.l.textContent === 'ADDED') { t.l.textContent = t.prev; }
          t.b.style.flex = '';
        });
        sync();
      }, 1650);
    }

    /* 담긴 걸 확인한 뒤에만 성공 문구 (최대 8회 × 300ms ≈ 2.4초) */
    function verify(before, tries, done) {
      if (tries > 8) { getCart().then(paintCount).catch(function () {}); done(); return; }
      setTimeout(function () {
        getCart()
          .then(function (c) {
            if (c.item_count > before) { paintCount(c); toast('Added to cart'); done(); }
            else { verify(before, tries + 1, done); }
          })
          .catch(function () { verify(before, tries + 1, done); });
      }, 300);
    }

    /* ---------------------------------------------------------------
       버튼 — ① 재고 있음: 담기  ② 없음: 알림 폼으로 이동
       --------------------------------------------------------------- */
    var proxyBtn = null;

    if (realBtn) {
      proxyBtn = document.createElement('button');
      proxyBtn.type = 'button';
      // 규격은 mlx-atc.css 가 단독 소유 — 클래스만 빌려 쓰고 여기서 재정의하지 않는다
      proxyBtn.className = 'mlx-atc button mlx-satc__bar';
      var lab = document.createElement('span');
      lab.className = 'mlx-atc__label';
      var pri = document.createElement('span');
      pri.className = 'mlx-atc__price';
      proxyBtn.appendChild(lab);
      proxyBtn.appendChild(pri);
      inner.appendChild(proxyBtn);

      proxyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (proxyBtn.disabled) { return; }
        if (!canAjax()) { submitFormNatively(); return; }
        addToCart();
      });

      /* ★ [2026-08-10 SB2] 인페이지 ATC 도 같은 경로로.
         바가 realBtn.click() 을 프록시하던 구조는 **폴백에만** 남는다
         (nativePass 플래그로 이 리스너를 통과시켜 폼이 그대로 제출된다).
         → 한 번의 사용자 동작에 cart/add.js 는 정확히 1회. */
      realBtn.addEventListener('click', function (e) {
        if (nativePass) { return; }        // 폴백 제출 — 기본동작 그대로 둔다
        if (realBtn.disabled) { return; }
        if (!canAjax()) { return; }        // 종전 폼 제출 그대로 (preventDefault 하지 않는다)
        e.preventDefault();
        addToCart();
      }, true);
    } else {
      proxyBtn = document.createElement('button');
      proxyBtn.type = 'button';
      proxyBtn.className = 'mlx-satc__bar mlx-satc__bar--notify';
      proxyBtn.textContent = 'Notify me';
      inner.appendChild(proxyBtn);

      proxyBtn.addEventListener('click', function () {
        wrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var email = wrapper.querySelector('input[type="email"]');
        if (email) { setTimeout(function () { email.focus(); }, 420); }
      });
    }

    /* ---------------------------------------------------------------
       쉐이드 선택 시트 (2026-08-09)

       실측: 쉐이드를 고른 뒤 하단 바로 담으면 그 쉐이드가 정확히 담긴다.
       문제는 **바에 고를 수단이 없어서** 스크롤을 내려온 고객이 그냥 누르면
       기본값 1번이 담긴다는 것.

       ★ 여기서도 로직을 다시 만들지 않는다 — 시트 항목은 인페이지 스와치의
         `<label>` 을 click 할 뿐이다. variant 전환·가격·이미지·품절 판정은
         테마 기존 경로가 하고, 바는 기존 sync() 로 따라온다.

       스와치 DOM (실측):
         div.swatch-element.color.<handle>-swatch.available|soldout
           [data-value="1. Agave (Clear)"] [data-value-handle="1-agave-clear"]
           └ label[for="swatch-…"] > img.swatch__image
         ※ radio 는 이 컨테이너 밖에 있고 label[for] 로 연결된다 → label 을 클릭해야 한다.
       --------------------------------------------------------------- */
    var swatchEls = form ? [].slice.call(form.querySelectorAll('.swatch-element')) : [];
    var sheet = null;
    var lastFocus = null;

    function shadeName(el) {
      return (el.getAttribute('data-value') || el.getAttribute('aria-label') || '').trim();
    }
    function isSoldOut(el) {
      return el.classList.contains('soldout') || el.classList.contains('sold-out');
    }
    function isCurrent(el) {
      if (el.classList.contains('active') || el.classList.contains('is-active')) { return true; }
      /* [2026-08-10 SB] ④ 종전에는 "절대 안 맞는 값"으로 NUL(0x00) 문자를 넣어 뒀다
         (`: '<NUL>'`). 눈에 안 보이는 제어문자를 소스에 남길 이유가 없다 —
         "현재 값을 모르면 아무것도 현재가 아니다" 를 조건으로 그대로 쓴다(동작 동일). */
      var cur = currentOptionName();
      return !!cur && shadeName(el) === cur;
    }

    /* ---------------------------------------------------------------
       [2026-08-10 SB] ① 배경 스크롤 잠금 — 카드(mlx-card-atc.js)와 같은 방식

       패널에 `aria-modal="true"` 를 선언해 놓고 실제로는 뒤가 스크롤됐다.
       선언(스크린리더에는 모달이라고 말함)과 동작이 어긋난 상태였다.
       ★ `overflow:hidden` 만으로는 iOS 사파리에서 안 잡힌다 → position:fixed + top:-scrollY.
         그러면 문서가 맨 위로 튀므로 top 으로 되돌려 두고, 풀 때 정확히 그 자리로 복귀한다.
       ★ 스크롤바가 사라지며 생기는 가로 이동은 padding-right 로 상쇄(데스크톱).
       ★ PDP 에는 추천상품 카드가 있어 mlx-card-atc.js 도 같이 살아 있다. 두 시트가 동시에
         열리진 않지만, 먼저 잠근 쪽이 복원 책임을 갖게 잠금 소유권을 명시한다
         (겹쳐 잠그면 복원 위치가 0 으로 튄다).
       --------------------------------------------------------------- */
    var lockY = 0;
    var lockOn = false;

    function lockScroll() {
      var b = document.body;
      if (lockOn) { return; }
      // 다른 스크립트가 이미 잠갔으면 건드리지 않는다
      if (b.getAttribute('data-mlx-locked') === '1' || b.style.position === 'fixed') { return; }
      lockY = window.pageYOffset || document.documentElement.scrollTop || 0;
      var sbw = window.innerWidth - document.documentElement.clientWidth;
      b.__mlxSatcPrev = {
        position: b.style.position, top: b.style.top, left: b.style.left,
        right: b.style.right, width: b.style.width, paddingRight: b.style.paddingRight
      };
      b.style.position = 'fixed';
      b.style.top = (-lockY) + 'px';
      b.style.left = '0';
      b.style.right = '0';
      b.style.width = '100%';
      if (sbw > 0) { b.style.paddingRight = sbw + 'px'; }
      b.setAttribute('data-mlx-locked', '1');
      lockOn = true;
    }

    function unlockScroll() {
      if (!lockOn) { return; }
      var b = document.body;
      var p = b.__mlxSatcPrev || {};
      b.style.position = p.position || '';
      b.style.top = p.top || '';
      b.style.left = p.left || '';
      b.style.right = p.right || '';
      b.style.width = p.width || '';
      b.style.paddingRight = p.paddingRight || '';
      b.removeAttribute('data-mlx-locked');
      lockOn = false;
      /* 'auto' 로 즉시 복귀 — smooth 로 두면 되돌아가는 게 눈에 보인다 */
      window.scrollTo(0, lockY);
    }

    /* [2026-08-10 SB] ① 포커스 트랩 — aria-modal 선언대로 Tab 이 시트 밖으로 못 나가게 */
    function focusables() {
      if (!sheet) { return []; }
      var panel = sheet.querySelector('.mlx-satc-sheet__panel');
      if (!panel) { return []; }
      var all = panel.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      return [].filter.call(all, function (el) {
        return !el.disabled && el.getAttribute('tabindex') !== '-1' && el.getBoundingClientRect().height > 0;
      });
    }

    function closeSheet() {
      if (!sheet) { return; }
      sheet.classList.remove('is-open');
      sheet.setAttribute('aria-hidden', 'true');
      document.removeEventListener('keydown', onSheetKey, true);
      unlockScroll();
      if (lastFocus && lastFocus.focus) { lastFocus.focus(); }
    }

    function onSheetKey(e) {
      if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); closeSheet(); return; }

      if (e.key !== 'Tab') { return; }
      var f = focusables();
      if (!f.length) { return; }
      var first = f[0];
      var last = f[f.length - 1];
      var active = document.activeElement;
      if (e.shiftKey) {
        if (active === first || !sheet.contains(active)) { e.preventDefault(); last.focus(); }
      } else {
        if (active === last || !sheet.contains(active)) { e.preventDefault(); first.focus(); }
      }
    }

    function buildSheet() {
      sheet = document.createElement('div');
      sheet.className = 'mlx-satc-sheet';
      sheet.setAttribute('aria-hidden', 'true');

      var scrim = document.createElement('div');
      scrim.className = 'mlx-satc-sheet__scrim';
      scrim.addEventListener('click', closeSheet);
      sheet.appendChild(scrim);

      var panel = document.createElement('div');
      panel.className = 'mlx-satc-sheet__panel';
      panel.setAttribute('role', 'dialog');
      panel.setAttribute('aria-modal', 'true');
      panel.setAttribute('aria-label', 'Choose a shade');
      sheet.appendChild(panel);

      var head = document.createElement('div');
      head.className = 'mlx-satc-sheet__head';
      var h = document.createElement('span');
      h.className = 'mlx-satc-sheet__title';
      h.textContent = 'Choose a shade';
      var x = document.createElement('button');
      x.type = 'button';
      x.className = 'mlx-satc-sheet__close';
      x.setAttribute('aria-label', 'Close');
      x.innerHTML = '&times;';
      x.addEventListener('click', closeSheet);
      head.appendChild(h);
      head.appendChild(x);
      panel.appendChild(head);

      var list = document.createElement('ul');
      list.className = 'mlx-satc-sheet__list';
      panel.appendChild(list);

      swatchEls.forEach(function (el) {
        var name = shadeName(el);
        if (!name) { return; }
        var out = isSoldOut(el);

        var li = document.createElement('li');
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'mlx-satc-sheet__item';
        if (out) { btn.disabled = true; }

        var img = el.querySelector('img.swatch__image') || el.querySelector('img');
        var sw = document.createElement('img');
        sw.className = 'mlx-satc-sheet__sw';
        sw.alt = '';
        sw.setAttribute('aria-hidden', 'true');
        if (img) { sw.setAttribute('src', img.currentSrc || img.src || img.getAttribute('data-src') || ''); }
        btn.appendChild(sw);

        var nm = document.createElement('span');
        nm.className = 'mlx-satc-sheet__nm';
        nm.textContent = name;
        btn.appendChild(nm);

        if (out) {
          var so = document.createElement('span');
          so.className = 'mlx-satc-sheet__so';
          so.textContent = 'Sold out';
          btn.appendChild(so);
        }

        btn.addEventListener('click', function () {
          if (out) { return; }
          // ★ 인페이지 스와치를 대신 눌러 준다. 상태는 테마가 관리한다.
          var lab = el.querySelector('label');
          (lab || el).click();
          closeSheet();
          setTimeout(sync, 60);
          setTimeout(sync, 320);
        });

        li.appendChild(btn);
        list.appendChild(li);
      });

      document.body.appendChild(sheet);
    }

    function openSheet() {
      if (!sheet) { buildSheet(); }
      lastFocus = document.activeElement;
      // 현재 선택 표시는 열 때마다 다시 계산한다(인페이지에서 바꿨을 수 있다)
      var items = sheet.querySelectorAll('.mlx-satc-sheet__item');
      swatchEls.forEach(function (el, i) {
        if (items[i]) { items[i].setAttribute('aria-current', isCurrent(el) ? 'true' : 'false'); }
      });
      sheet.classList.add('is-open');
      sheet.setAttribute('aria-hidden', 'false');
      document.addEventListener('keydown', onSheetKey, true);
      lockScroll();
      /* 현재 쉐이드가 품절이면 focus() 가 먹지 않는다 → 첫 선택 가능 항목으로 (카드와 동일) */
      var cur = sheet.querySelector('.mlx-satc-sheet__item[aria-current="true"]:not([disabled])') ||
                sheet.querySelector('.mlx-satc-sheet__item:not([disabled])');
      if (cur) { cur.focus(); }
    }

    /* [2026-08-09 rev2] meta 전체를 버튼으로 만들지 않는다.
       rev1 은 meta 를 통째로 버튼화하고 상품명을 숨겼는데, 데스크톱에서
       meta 가 flex:1 1 auto 라 **빈 폼 필드처럼 가로로 늘어났고 상품명이 사라졌다.**
       → 상품명은 보이게 두고, **쉐이드만 별도의 작은 pill 버튼**으로 뺀다.
         버튼 안에 현재 쉐이드 스와치를 넣어 "색을 고르는 곳"으로 읽히게 한다. */
    var shadeDotEl = null;
    if (swatchEls.length > 1) {
      bar.classList.add('mlx-satc--has-shades');

      var shadeBtn = document.createElement('button');
      shadeBtn.type = 'button';
      shadeBtn.className = 'mlx-satc__shade';
      shadeBtn.setAttribute('aria-haspopup', 'dialog');

      shadeDotEl = document.createElement('img');
      shadeDotEl.className = 'mlx-satc__dot';
      shadeDotEl.alt = '';
      shadeDotEl.setAttribute('aria-hidden', 'true');
      shadeBtn.appendChild(shadeDotEl);

      shadeBtn.appendChild(variantEl);   // 쉐이드 텍스트를 버튼 안으로 옮긴다

      var caret = document.createElement('span');
      caret.className = 'mlx-satc__caret';
      caret.setAttribute('aria-hidden', 'true');
      caret.textContent = '▾';
      shadeBtn.appendChild(caret);

      meta.appendChild(shadeBtn);
      shadeBtn.addEventListener('click', openSheet);
    }

    var toastEl = document.createElement('div');
    toastEl.className = 'mlx-satc__toast';
    toastEl.setAttribute('role', 'status');
    toastEl.setAttribute('aria-live', 'polite');
    bar.appendChild(toastEl);
    var toastTimer = null;
    function toast(msg) {
      toastEl.textContent = msg;

      /* ★ 클라비요 하단 티저를 피해 띄운다.
         종전에는 토스트가 뜬 적이 없어서(폼 제출로 페이지가 새로고침됐다) 드러나지 않았던 문제다.
         실측 375: 토스트 719–752 / 티저 698–748(z 90000) → elementFromPoint(토스트 중앙)이
         **티저**를 집었다 = 성공 문구가 통째로 가려진다.
         티저는 우리 것이 아니고 있을 때만 있으므로 **런타임에 재서** 그만큼 올린다.
         (카드 mlx-card-atc.js 의 toast 와 같은 처방) */
      var lift = 8;
      var teaser = document.querySelector('[class*="kl-teaser"]');
      if (teaser) {
        var tr = teaser.getBoundingClientRect();
        var br = bar.getBoundingClientRect();
        if (tr.height > 0 && tr.bottom > br.top - 8) { lift = Math.round(br.top - tr.top) + 8; }
      }
      toastEl.style.bottom = 'calc(100% + ' + lift + 'px)';

      toastEl.classList.add('is-on');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 1800);
    }

    document.body.appendChild(bar);

    /* ---------------------------------------------------------------
       인페이지 바 미러링 (라벨 · 가격 · 품절 · 썸네일 · 선택값)
       --------------------------------------------------------------- */
    var realLabel = realBtn ? realBtn.querySelector('.mlx-atc__label') : null;
    var realPrice = realBtn ? realBtn.querySelector('[data-sfp-atc-price]') : null;
    var realRow = realBtn && realBtn.closest ? realBtn.closest('.mlx-atc-row') : null;

    function sync() {
      if (realBtn) {
        var l = proxyBtn.querySelector('.mlx-atc__label');
        var p = proxyBtn.querySelector('.mlx-atc__price');
        // ADDED 를 띄운 동안에는 라벨을 덮지 않는다 (가격·품절 미러링은 계속한다)
        if (realLabel && l && Date.now() > labelHold && l.innerHTML !== realLabel.innerHTML) {
          l.innerHTML = realLabel.innerHTML;
        }
        if (realPrice && p && p.innerHTML !== realPrice.innerHTML) { p.innerHTML = realPrice.innerHTML; }

        // 품절: 섹션 JS 가 실제 버튼에 걸어 두는 상태를 그대로 따라간다
        var out = realBtn.disabled ||
                  realBtn.classList.contains('disabled') ||
                  (realRow && realRow.classList.contains('is-sold-out'));
        proxyBtn.disabled = !!out;
        proxyBtn.classList.toggle('disabled', !!out);
      }

      /* 선택값은 좁은 칸(모바일 96px)에 들어가야 하므로 군더더기를 뗀다.
           "1. Agave (Clear)"  → "Agave"
           "11. Autumn Rain (Tinted)" → "Autumn Rain"
         ★ 앞 번호는 `숫자 + 마침표 + 공백` 일 때만 뗀다.
           공백을 요구하지 않으면 선크림의 "1.7 fl oz / 50 mL" 이 "7 fl oz" 가 된다.
         ★ [2026-08-10 SB] ③ 출처를 currentOptionName() 으로 바꿨다(딥링크 초기값 오염 회피). */
      var raw = currentOptionName();
      if (raw) {
        var v = raw
          .replace(/^\d{1,2}\.\s+/, '')
          .replace(/\s*\([^)]*\)\s*$/, '')
          .trim();
        if (v && variantEl.textContent !== v) { variantEl.textContent = v; }

        /* [2026-08-10 SB2] 인페이지 쉐이드 라벨도 같은 값으로 되돌린다.
           섹션 JS(product__main-sf-lip.liquid) syncLabel() 이 파싱 시점에
           `forloop.first` radio 를 읽어 **1번 쉐이드**로 덮어쓰기 때문
           (딥링크 6 Rosewood 인데 "0 Glass"). 뿌리는 섹션이지만 그 파일은 64KB —
           전송 위험 때문에 여기서 같은 우선순위로 교정한다(보고서 기재).
           mo 가 이 쓰기를 다시 물어도 값이 같으면 조건에서 멈춘다(루프 없음). */
        if (selectedEl && selectedEl.textContent.trim() !== raw) {
          selectedEl.textContent = raw;
        }
      }

      /* pill 안의 현재 쉐이드 스와치 */
      if (shadeDotEl) {
        var curSw = null;
        for (var si = 0; si < swatchEls.length; si++) {
          if (isCurrent(swatchEls[si])) { curSw = swatchEls[si]; break; }
        }
        var ci = curSw && (curSw.querySelector('img.swatch__image') || curSw.querySelector('img'));
        if (ci) {
          var cs = ci.currentSrc || ci.src || ci.getAttribute('data-src') || '';
          if (cs && shadeDotEl.getAttribute('src') !== cs) { shadeDotEl.setAttribute('src', cs); }
        }
      }

      /* 현재 갤러리 메인 이미지.
         ★ 화면 밖 슬라이드는 lazysizes 가 아직 안 채워서 currentSrc/src 가
           `data:image/svg…` 플레이스홀더다(실측). 그때는 data-src 로 떨어진다. */
      var cur = document.querySelector('.product-gallery__main .is-selected img') ||
                document.querySelector('.product-gallery__main img');
      var src = '';
      if (cur) {
        src = cur.currentSrc || cur.src || '';
        if (!src || src.indexOf('data:image/svg') === 0) { src = cur.getAttribute('data-src') || ''; }
        if (src.indexOf('{width}') > -1) { src = src.replace('{width}', '200'); }
      }
      if (src && src.indexOf('data:image/svg') !== 0 && thumb.getAttribute('src') !== src) {
        thumb.setAttribute('src', src);
      }
    }

    sync();

    if (window.MutationObserver) {
      var mo = new MutationObserver(function () { setTimeout(sync, 0); });
      if (realBtn) { mo.observe(realBtn, { childList: true, subtree: true, characterData: true, attributes: true }); }
      if (selectedEl) { mo.observe(selectedEl, { childList: true, subtree: true, characterData: true }); }
    }
    // 섹션 JS 가 가격을 되돌리는 타이밍(최대 140ms)보다 뒤에서 한 번 더 읽는다
    if (form) {
      form.addEventListener('change', function () { setTimeout(sync, 30); setTimeout(sync, 200); });
      form.addEventListener('click', function () { setTimeout(sync, 200); });
    }

    /* ---------------------------------------------------------------
       노출 조건
         · 인페이지 ATC 를 **위로 지나쳤을 때만** 올라온다.
           첫 로드 시 아직 도달하지 않은 상태(아래에 있음)에서는 띄우지 않는다 —
           바로 아래 실제 버튼이 있는데 고정 바까지 겹치면 중복이다.
         · 한 번 올라오면 페이지 끝까지 내리지 않는다.
           ★ 처음엔 "푸터가 보이면 내린다"로 했다가 되돌렸다(실측 2026-08-09):
             미스트세럼처럼 A+·리뷰가 없는 짧은 페이지(문서 2,232px)는
             푸터가 y=776 에서 이미 보이는데 인페이지 ATC 는 y=848 에서야 지나간다.
             → 겹치는 구간이 없어 바가 **끝까지 한 번도 안 떴다.**
             대신 html 에 클래스를 걸어 CSS 로 문서 아래 여백을 만든다(레이아웃 시프트 0).
       --------------------------------------------------------------- */
    var anchor = host || realBtn || wrapper;
    var shown = null;
    var ticking = false;

    // 바 높이만큼 문서 끝에 여백 — 푸터 마지막 줄이 가리지 않게
    document.documentElement.classList.add('mlx-satc-on');

    /* IntersectionObserver 를 쓰지 않는다.
       실측(2026-08-09, 립버터 375px): 앵커를 2,000px 넘게 지나쳤는데도 콜백이
       기대대로 안 와서 바가 안 떴다.
       getBoundingClientRect 로 매 프레임 직접 판정하면 발화 순서 의존이 사라진다.
       rAF 스로틀 + passive 라 스크롤 비용은 무시할 수준. */
    /* [2026-08-09 rev3] 진입 즉시 노출로 변경 — 경쟁사 실측 근거.
       Rhode(375×72) · Summer Fridays(375×90) **둘 다 PDP 진입 즉시** 고정 바가 떠 있다.
       우리는 스크롤 2,200px 이후에야 떴다. 처음엔 "인페이지 ATC 가 바로 아래 보이는데
       고정 바까지 겹치면 중복"이라고 판단했는데, 경쟁 2사가 모두 그 중복을 감수한다
       = 업계 표준이고, 우리 판단이 틀렸다.
       콘텐츠가 가려지는 문제는 이미 `.mlx-satc-on body{padding-bottom}` 으로 막아 뒀다.
       ★ 되돌리려면 이 상수만 false 로. 아래 스크롤 판정 로직은 그대로 살아 있다. */
    var SHOW_IMMEDIATELY = true;

    function apply() {
      // 즉시 노출이거나, 인페이지 ATC 를 위로 지나쳤거나
      var show = SHOW_IMMEDIATELY || anchor.getBoundingClientRect().bottom < 0;
      if (show === shown) { return; }
      shown = show;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      // 클라비요 티저를 바 위로 밀어 올리기 위한 훅 (규칙은 CSS 쪽 FX-KL)
      document.documentElement.classList.toggle('mlx-satc-visible', show);
      if (show) { sync(); }
    }

    function onScroll() {
      if (ticking) { return; }
      ticking = true;
      requestAnimationFrame(function () { ticking = false; apply(); });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    window.addEventListener('load', apply);
    apply();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
